import React from 'react';
import PropTypes from 'prop-types';

export const InternalAuthenticatorContext = React.createContext();

export const InternalAuthenticatorContextProvider = ({
  userId = '',
  children
}) => {
  return (
    <InternalAuthenticatorContext.Provider value={userId}>
      {children}
    </InternalAuthenticatorContext.Provider>
  );
};

InternalAuthenticatorContextProvider.propTypes = {
  userId: PropTypes.string
};
